export default __webpack_public_path__ + "static/media/p2p-icon.bb41b54d.webp";